import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Common } from "../../utils/common";

const $ = window.$;

function DNICampaignsTable({ tableData }) {
  const [isOpen, setIsOpen] = useState(true);
  const tableEl = useRef();

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      data: tableData,
      dom: "<fB>tlip",
      lengthMenu: [
        [10, 25, 50, 100, 200, -1],
        [10, 25, 50, 100, 200, "All"],
      ],
      columnDefs: [{ className: "text-center", targets: "_all" }],
      stateSave: true,
      stateSaveCallback: function (oSettings, oData) {
        localStorage.setItem("DataTables-AI-Active-Campaigns", JSON.stringify(oData));
      },
      stateLoadCallback: function (oSettings) {
        return JSON.parse(localStorage.getItem("DataTables-AI-Active-Campaigns"));
      },
      buttons: [
        { extend: "colvis", text: "Select Columns", collectionLayout: "fixed two-column" },
        {
          extend: "excelHtml5",
          text: "Data Export",
          title: "DNI_campaigns",
          exportOptions: {
            columns: function (idx, data, node) {
              const hideFromExport = [];
              var isVisible = table.column(idx).visible();
              var isNotForExport = $.inArray(idx, hideFromExport) !== -1;
              return isVisible && !isNotForExport ? true : false;
            },
            orthogonal: "export",
          },
        },
      ],
      columns: columnBuilder(),
      responsive: true,
      destroy: true,
      footerCallback: function () {
        const api = this.api();

        const totalRows = api.rows().count();

        const totalSizeOfPool = api
          .column(3)
          .data()
          .reduce((a, b) => a + b, 0);

        const totalCalls = api
          .column(7)
          .data()
          .reduce((a, b) => a + b, 0);

          const totalProcessed = api
          .column(8)
          .data()
          .reduce((a, b) => a + b, 0);

        const totalTranscribed = api
          .column(9)
          .data()
          .reduce((a, b) => a + b, 0);
          
        const totalRedacted = api
          .column(10)
          .data()
          .reduce((a, b) => a + b, 0);

        const totalDuration = api
          .column(11)
          .data()
          .reduce((a, b) => a + b, 0);

        const totalTextEnabled = api
          .column(12)
          .data()
          .reduce((a, b) => a + b, 0);

        const totalMessages = api
          .column(13)
          .data()
          .reduce((a, b) => a + b, 0);

        $(api.column(2).footer()).html(Common.formatNumberWithCommas(totalRows));
        $(api.column(3).footer()).html(Common.formatNumberWithCommas(totalSizeOfPool));
        $(api.column(7).footer()).html(Common.formatNumberWithCommas(totalCalls));
        $(api.column(8).footer()).html(Common.formatNumberWithCommas(totalProcessed));
        $(api.column(9).footer()).html(Common.formatNumberWithCommas(totalTranscribed));
        $(api.column(10).footer()).html(Common.formatNumberWithCommas(totalRedacted));
        $(api.column(11).footer()).html(
          momentDurationToTime(moment.duration(totalDuration, "seconds"))
        );
        $(api.column(12).footer()).html(Common.formatNumberWithCommas(totalTextEnabled));
        $(api.column(13).footer()).html(Common.formatNumberWithCommas(totalMessages));
      },
    });

    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
    };
  }, [tableData]);

  return (
    <>
      <div
        className="active_campaigns_table_header"
        role="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <i className={isOpen ? "fa fa-caret-down" : "fa fa-caret-right"} /> DNI Campaigns
      </div>
      <div hidden={!isOpen} className="table-responsive" style={{ paddingBottom: "30px" }}>
        <table
          ref={tableEl}
          className="table table-hover table-striped vertical_centered table-bordered"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Domain Name</th>
              <th>Campaign Name</th>
              <th>Size of Pool</th>
              <th>Created</th>
              <th>Ended</th>
              <th>Status</th>
              <th>Number of Calls</th>
              <th>Processed Calls</th>
              <th>Transcribed Calls</th>
              <th>Redacted Calls</th>
              <th>Duration</th>
              <th>Texting Enabled</th>
              <th>SMS Count</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th colSpan={2} style={{ textAlign: "right" }}>
                Total:
              </th>
              <th style={{ textAlign: "center" }}></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );
}

function columnBuilder() {
  const columns = [];
  columns.push({ data: "location_name", className: " " });
  columns.push({ data: "domain_name", visible: false });
  columns.push({ data: "campaign_name", className: " " });
  columns.push({ data: "size_of_pool" });
  columns.push({
    data: "created_at",
    className: "text-center whitespace_nowrap",
    render: (data) => (data ? moment.utc(data).local().format("MMM D, YYYY hh:mm:ss A") : null),
  });
  columns.push({
    data: "ended_at",
    className: "text-center whitespace_nowrap",
    render: (data) => (data ? moment.utc(data).local().format("MMM D, YYYY hh:mm:ss A") : null),
  });
  columns.push({
    data: "status",
    render: (data) => {
      if (data === 1) {
        return "Active";
      }
      if (data === 2) {
        return "Paused";
      }
      if (data === 3) {
        return "Ended";
      } else {
        return null;
      }
    },
  });
  columns.push({
    data: "number_of_calls",
    render: $.fn.dataTable.render.number(","),
  });
  columns.push({
    data: "leadscore_calls",

    render: (data) =>
      data ? data : 0
  });
  columns.push({
    data: "transcribed_calls",

    render: (data) =>
      data ? data : 0
  });
  columns.push({
    data: "redacted_calls",

    render: (data) =>
      data ? data : 0
  });
  columns.push({
    data: "duration",
    render: (data) =>
      momentDurationToTime(moment.duration(Number(data), "seconds")),
  });
  columns.push({
    data: "texted_enabled",
    render: (data, type) => {
      if (type === "sort") {
        return data === 0;
      } else if (type === "export") {
        return data === 0 ? "No" : "Yes";
      } else {
        var className = data == 0 ? "glyphiconno glyphicon-remove" : "glyphiconyes glyphicon-ok";
        return `<i class='${className}'></i>`;
      }
    },
  });
  columns.push({
    data: "number_of_sms_messages",
    render: $.fn.dataTable.render.number(","),
  });
  return columns;
}

function momentDurationToTime(dur) {
  var hours = Math.floor(dur.asHours());
  var mins  = Math.floor(dur.asMinutes()) - hours * 60;
  var sec   = Math.floor(dur.asSeconds()) - hours * 60 * 60 - mins * 60;

  return ((hours > 9) ? hours : ("0"+hours)) + ":" + ((mins > 9) ? mins : ("0"+mins)) + ":" + ((sec > 9) ? sec : ("0"+sec));
}

DNICampaignsTable.propTypes = {
  tableData: PropTypes.array.isRequired,
};

export default DNICampaignsTable;
